import React from 'react'

const About = () => {
  return (
    <>
      <h1>About!</h1>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Excepturi delectus id adipisci suscipit atque culpa reiciendis facilis harum blanditiis voluptas magni, a itaque esse ex laborum vero earum, nam odio quisquam nihil. Doloribus quasi dolores saepe eius est. Veritatis sequi commodi molestias, ea illum doloribus et voluptatem tempore amet mollitia!
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Excepturi delectus id adipisci suscipit atque culpa reiciendis facilis harum blanditiis voluptas magni, a itaque esse ex laborum vero earum, nam odio quisquam nihil. Doloribus quasi dolores saepe eius est. Veritatis sequi commodi molestias, ea illum doloribus et voluptatem tempore amet mollitia!
      </p>
      <button ><a target='_blank' href="https://github.com/jamilahmed2/blog-app">Github Repo</a></button>
    </>
  )
}

export default About